import { useLocation } from 'react-router-dom'
import { Button } from '@w7/ui'
import { logout } from '@/auth/oidc'
import '@/styles/app.css'

type NoAccessState = {
  email?: string
  hierarchyLevel?: string
}

/**
 * Wrong-level accounts (e.g. member) must end the Keycloak SSO session — a plain
 * link to /login leaves the IdP cookie and re-issues a token for the same user.
 */
export function NoAccessPage() {
  const location = useLocation()
  const state = (location.state || {}) as NoAccessState
  const level = state.hierarchyLevel
  const email = state.email

  return (
    <div className="sm-login">
      <div className="sm-login-bg" aria-hidden="true" />
      <div className="sm-login-card">
        <div className="sm-login-brand">
          <img src="/brand/strix-logo.png" alt="" width={40} height={40} decoding="async" />
          <div>
            <strong>Company Master</strong>
            <span>CM console</span>
          </div>
        </div>
        <h1>No access</h1>
        <p className="sm-login-lede">
          This console is for Company Master accounts only (hierarchy level 1).
        </p>
        {email || level ? (
          <p className="sm-login-alert" role="status">
            Signed in as {email || 'unknown'}
            {level != null && level !== '' ? ` (hierarchy level ${level})` : ' (no hierarchyLevel claim)'}
            . Use a level-1 CM account such as <code>agents-cm@rimora.org</code>.
          </p>
        ) : (
          <p className="sm-login-lede">
            Sign in with a Company Master user (for example <code>agents-cm@rimora.org</code>), not a
            member or TM account.
          </p>
        )}
        <div style={{ marginTop: 16 }}>
          <Button type="button" variant="primary" onClick={() => logout()}>
            Sign out &amp; switch account
          </Button>
        </div>
      </div>
    </div>
  )
}
